import { selectLanguages } from 'appConstants';
import { SetStateType } from 'commonTypes';
import { useIntl } from 'react-intl';
import TextareaAutosize from 'react-textarea-autosize';

interface AddOptionSecondStepProps {
  optionNameTranslate: Record<string, string>;
  loadingTranslate: boolean;
  setOptionNameTranslate: SetStateType<Record<string, string>>;
}

export const AddOptionSecondStep = ({
  optionNameTranslate,
  loadingTranslate,
  setOptionNameTranslate,
}: AddOptionSecondStepProps) => {
  const intl = useIntl();

  return (
    <div className="mt-4 flex w-full flex-col space-y-4 mb-3">
      {Object.keys(optionNameTranslate).length > 0 &&
        !loadingTranslate &&
        Object.keys(optionNameTranslate).map((item, index) => {
          return (
            <div
              key={'edit-translate-option-name-' + index}
              className="grid grid-cols-[1fr_4fr] items-center space-x-3 rtl:space-x-reverse w-full"
            >
              <h2 className="rtl:text-right">
                {selectLanguages
                  ?.find((elem) => {
                    return elem.value === item;
                  })
                  ?.value.toUpperCase()}
              </h2>
              <div>
                <TextareaAutosize
                  minRows={2}
                  className="mb-4 last:mb-0 w-full scrollbar rounded-md border-gray-300 sm:text-sm"
                  placeholder={intl.formatMessage({ id: 'optionName' })}
                  value={optionNameTranslate[item]}
                  disabled={loadingTranslate}
                  onChange={(e) => {
                    setOptionNameTranslate((prev) => {
                      return {
                        ...prev,
                        [item]: e.target.value,
                      };
                    });
                  }}
                />
              </div>
            </div>
          );
        })}
    </div>
  );
};
